/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentWebId = (state) => get(state, ['currentWeb', 'id']);

export const getCurrentWeb = (state) => {

    return get(state, ['currentWeb', 'items'], []);
};

export const getCurrentWebDenormalized = (state) => {
    let currentWeb = getCurrentWeb(state);

    if (!currentWeb) {
        return null;
    }

    const coupons = getAllCoupons(state);
    const addons = getAllAddons(state);

    currentWeb = {
        ...currentWeb,
        coupons: reverse(sortBy(map(currentWeb.coupons, ({ coupon_id }) => find(coupons, { id: coupon_id })), ({ discount_percentage}) => {
            return discount_percentage;
        })),
    };

    let realTotal = currentWeb.plan_amount;

    get(currentWeb, 'coupons', []).forEach(coupon => {
        let discount = realTotal * (coupon.discount_percentage / 100);
        realTotal = realTotal - discount;
    })

    return { ...currentWeb, estimateTotal: realTotal };
};

export const requestingCurrentWeb = (state) => get(state, ['currentWeb', 'requesting'], false);

export const errorRequestingCurrentWeb = (state) => get(state, ['currentWeb', 'error'], false);

export const getCurrentWebPlanId = createSelector(
    getCurrentWeb,
    (currentWeb) => {
        return get(currentWeb, ['plan_id'], null);
    },
);

export const hasScheduledChanges = createSelector(
    getCurrentWeb,
    (currentWeb) => {
        return get(currentWeb, ['has_scheduled_changes'], false);
    },
);
